// extracted by mini-css-extract-plugin
export var cartContainer = "_pe-4";
export var gray = "_pe-1";
export var itemContainer = "_pe-2";
export var itemDetails = "_pe-3";
export var strong = "_pe-0";